import vue from 'vue';
import vuex from 'vuex';
vue.use(vuex);

const state = {
  baseUrl: process.env.VUE_APP_baseURL5,
  baseUrls: 'https://api.inter-link.top/',
  page_tit: '',
  userInfo: '', //个人信息
  systemLanguage: localStorage.getItem('lang'), //系统语言
  current: 0,
  active: 0,
  langInfo:{},
};
const mutations = {
  //获取个人信息
  setuserInfo(state, info) {
    state.userInfo = info;
  },
  //设置页面标题
  setPageTit(state, txt) {
    state.page_tit =txt;
    console.log('==========================', state);
  },
  changeActive(state, num) {
    state.active = num;
  },
  changeCurrent(state, num) {
    state.current = num;
    state.active = 0;
  },

}
const actions = {
 
}

export default new vuex.Store({
  state,
  mutations,
  actions
})



// WEBPACK FOOTER //
// ./src/store/index.js